import { FC } from 'react';
import { Card, HStack, Text } from '@wegroup/design-system';
import TableCheckbox from '@parties/src/features/overview/components/table/TableCheckbox';
import { useYellowhiveFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/yellowhiveFlowsConfigureStore';
import { SchemaYellowHiveInsurance } from 'wg-api-sdk';

interface Props {
  insurance: SchemaYellowHiveInsurance;
  isError?: boolean;
  clearError?: () => void;
}

const FlowsConfigureInsuranceItem: FC<Props> = ({
  insurance,
  isError,
  clearError,
}) => {
  const setInsurances = useYellowhiveFlowsConfigureStore(
    (state) => state.setInsurances,
  );
  const isSelected = useYellowhiveFlowsConfigureStore((state) => {
    const found = state.insurances.some((item) => {
      return item.code === insurance.code;
    });
    return found;
  });

  const handleSelect = () => {
    const updatedInsurances = isSelected
      ? useYellowhiveFlowsConfigureStore
          .getState()
          .insurances.filter((item) => item.code !== insurance.code)
      : [...useYellowhiveFlowsConfigureStore.getState().insurances, insurance];
    if (isError) clearError?.();
    setInsurances(updatedInsurances);
  };

  return (
    <Card
      as="button"
      p="4"
      borderColor={
        isError ? 'danger.main' : isSelected ? 'primary.500' : 'gray.50'
      }
      h="100%"
      onClick={() => handleSelect()}
      _hover={{
        borderColor: isSelected ? undefined : 'gray.100',
        boxShadow: isError ? undefined : 'level2',
      }}
      cursor="pointer"
      transition="0.1s"
    >
      <HStack spacing="3">
        <Text flexGrow="1">{insurance.name}</Text>
        <TableCheckbox isChecked={isSelected} onChange={() => null} />
      </HStack>
    </Card>
  );
};

export default FlowsConfigureInsuranceItem;
